export const latinExtdRegEx = /([\u0061-\u007a \u0020 \r\n \u0027-\u002F \u0030-\u003A \u003F \u0041-\u005A \u0061-\u007A \u00C0-\u00FF \u0100-\u017F \u0180-\u024F]+)/g
